import * as types from '@/store/types.js'
import router from '@/router'
import store from '@/store/index'
import displayError from '@/helpers/displayError'
import app from '../main'

export default {
  baseUrl () {
    return 'sliders'
  },

  index (request) {
    return axios.get(this.baseUrl(), { params: request })
  },

  show (id) {
    return axios.get(`${this.baseUrl()}/${id}`)
  },

  create (request) {
    return axios.post(`${this.baseUrl()}`, {
      slider: request
    }).then((response) => {
      app.$snotify.success('Successfully created.')
      store.dispatch(types.ADD_SLIDER, response.data.data)
      router.push({ name: `${app.$route.path.split('/')[1]}.edit`, params: { id: response.data.data.id } })
    }).catch((error) => {
      displayError(error)
    })
  },

  update (request, sendMessage = true) {
    return axios.put(`${this.baseUrl()}/${request.id}`, {
      slider: request
    }).then((response) => {
      if (sendMessage) {
        app.$snotify.success('Successfully updated.')
      }
    }).catch((error) => {
      displayError(error)
    })
  },

  delete (request) {
    return axios.delete(`${this.baseUrl()}/${request.id}`)
  }
}



// WEBPACK FOOTER //
// ./src/model/Slider.js